import { render } from "./WhaleProfileView.vue?vue&type=template&id=526405fa&scoped=true"
import script from "./WhaleProfileView.vue?vue&type=script&lang=js"
export * from "./WhaleProfileView.vue?vue&type=script&lang=js"

import "./WhaleProfileView.vue?vue&type=style&index=0&id=526405fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526405fa"]])

export default __exports__